<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <p class="text-h3">Política de privacidde {{ appName }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      appName: "GGrupos",
    };
  },
  mounted() {},
  activated() {},
  methods: {},
  computed: {},
};
</script>